import { updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

const initialState = {
  HelpContent: {},
  HelpCount: 0,
  loading: false,
  error: null,
};

const fetchHelpContentStart = (state) => {
  return updateObject(state, {
    HelpContent: {},
    HelpCount: 0,
    loading: true,
    error: null,
  });
};

const fetchHelpContentSuccess = (state, action) => {
  return updateObject(state, {
    HelpContent: action.HelpContent,
    HelpCount: action.HelpCount,
    loading: false,
    error: null,
  });
};

const fetchHelpContentFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HELP_CONTENT_START:
      return fetchHelpContentStart(state, action);
    case actionTypes.FETCH_HELP_CONTENT_SUCCESS:
      return fetchHelpContentSuccess(state, action);
    case actionTypes.FETCH_HELP_CONTENT_FAILED:
      return fetchHelpContentFailed(state, action);
    default:
      return state;
  }
};
export default reducer;
